import React from 'react';
import {StyleSheet, View} from 'react-native';

import theme from '../style/theme';

const ViewStyled = props => {
  let propStyle = {};
  if (Array.isArray(props.style)) {
    propStyle = StyleSheet.flatten(props.style);
  } else {
    propStyle = props.style;
  }

  return (
    <View {...props} style={[styles.container, propStyle]}>
      {props.children}
    </View>
  );
};

export default ViewStyled;

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colour.background.general.primary,
  },
});
